// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 768px) {
  div.preview {
    display: none;
  }
}
.preview-wrapper .hero {
  width: 100%;
  background-color: inherit;
}`, "",{"version":3,"sources":["webpack://./packages/react-hook-schema/components/src/lib/components/SchemaFormPage/SchemaForm.scss"],"names":[],"mappings":"AAAA;EACE;IACE,aAAA;EACF;AACF;AAGE;EACE,WAAA;EACA,yBAAA;AADJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
